(function ($) {
    "use strict";
    $(function () {

        if ($(".js-residential-details-slider").length) {
            const initResidentialSlider = () => {
                let residentialSlider = document.querySelectorAll(".js-residential-details-slider");
                let prevArrow = document.querySelectorAll(".js-residential-slider-prev");
                let nextArrow = document.querySelectorAll(".js-residential-slider-next");
                let pagination = document.querySelectorAll(".js-residential-slider-pagination");

                residentialSlider.forEach((slider, index) => {
                    let sliderLength = slider.children[0].children.length;
                    const swiper = new Swiper(slider, {
                        navigation: {
                            nextEl: nextArrow[index],
                            prevEl: prevArrow[index],
                        },
                        pagination: {
                            el: pagination[index],
                            type: "custom",
                            renderCustom: function (swiper, current, total) {
                                return current + "/" + total;
                            },
                        },
                        on: {
                            slideChange: function () {
                                stopAllVideos();
                                startVideoOnActiveSlide(this);
                            }
                        }
                    });
                });
            };

            const stopAllVideos = () => {
                document.querySelectorAll('.js-slider-video').forEach(video => {
                    if (!video.paused) {
                        video.pause();
                    }
                });
            };

            const startVideoOnActiveSlide = (swiper) => {
                const activeSlide = swiper.slides[swiper.activeIndex];
                const video = activeSlide.querySelector('.js-slider-video');
                if (video) {
                    video.play();
                }
            };

            initResidentialSlider()
        }

        if ($(".js-text-slider").length) {
            const initTextSlider = () => {
                let textSlider = document.querySelectorAll(".js-text-slider");
                let prevArrow = document.querySelectorAll(".js-text-slider-prev");
                let nextArrow = document.querySelectorAll(".js-text-slider-next");

                let prevArrowMobile = document.querySelectorAll(".js-text-slider-prev--mobile");
                let nextArrowMobile = document.querySelectorAll(".js-text-slider-next--mobile");
                let paginationMobile = document.querySelectorAll(".js-text-slider-pagination--mobile");
                let pagination = document.querySelectorAll(".js-text-slider-pagination");

                textSlider.forEach((slider, index) => {
                    // this bit checks if there's more than 1 slide, if there's only 1 it won't loop
                    let sliderLength = slider.children[0].children.length;
                    let result = sliderLength > 1 ? true : false;
                    const swiper = new Swiper(slider, {
                        navigation: {
                            nextEl: nextArrowMobile[index],
                            prevEl: prevArrowMobile[index],
                        },
                        pagination: {
                            el: paginationMobile[index],
                            type: "custom",
                            renderCustom: function (swiper, current, total) {
                                return current + "/" + total;
                            },
                        },
                        breakpoints: {
                            992: {
                                navigation: {
                                    nextEl: nextArrow[index],
                                    prevEl: prevArrow[index],
                                },
                                pagination: {
                                    el: pagination[index],
                                    type: "custom",
                                    renderCustom: function (swiper, current, total) {
                                        return current + "/" + total;
                                    },
                                },
                            },
                        },
                    });
                });
            };
            initTextSlider();
        }


        if ($(".js-hero-swiper").length) {
            var divsCollection = $("#container-mov");
            var randomMax = $(divsCollection).find(".swiper-slide").length;
            var randNum = Math.floor(Math.random() * randomMax) + 0;
            var heroSwiper = new Swiper(".js-hero-swiper", {
                allowTouchMove: false,
                initialSlide: randNum

            });
        }




        if (document.querySelectorAll(".js-hero-marina-swiper").length) {
            const initHeroSliderMarina = () => {
                const heroSliderMarina = document.querySelectorAll(".js-hero-marina-swiper");
                const prevArrow = document.querySelectorAll(".js-marina-slider-prev");
                const nextArrow = document.querySelectorAll(".js-marina-slider-next");
                const pagination = document.querySelectorAll(".js-marina-slider-pagination");

                const playVideoAndHandleEnd = (video, swiper) => {
                    video.play();
                    swiper.autoplay.stop();
                    video.addEventListener("ended", () => {
                        swiper.slideNext();
                        swiper.autoplay.start();
                    });
                };

                heroSliderMarina.forEach((slider, index) => {
                    const swiper = new Swiper(slider, {
                        autoplay: false,
                        effect: 'fade',
                        fadeEffect: { crossFade: true },
                        loop: true,
                        navigation: { nextEl: nextArrow[index], prevEl: prevArrow[index] },
                        pagination: {
                            el: pagination[index],
                            type: "custom",
                            renderCustom: (swiper, current, total) => `${current}/${total}`,
                        },
                    });

                    swiper.on("slideChangeTransitionEnd", () => {
                        const video = slider.querySelector(".swiper-slide-active video");
                        if (video) {
                            playVideoAndHandleEnd(video, swiper);
                        } else {
                            swiper.autoplay.start();
                        }
                    });

                    const heroSwiperObserver = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                swiper.params.autoplay = { delay: 5000, disableOnInteraction: false };
                                const video = slider.querySelector(".swiper-slide-active video");
                                if (video) {
                                    playVideoAndHandleEnd(video, swiper);
                                } else {
                                    swiper.autoplay.start();
                                }
                            } else {
                                swiper.autoplay.stop();
                            }
                        });
                    }, { threshold: 0.5 });

                    heroSwiperObserver.observe(slider);
                });
            };
            initHeroSliderMarina();
        }





        if ($(".js-fp-residential-swiper").length && $(window).width() < 992) {
            const residentialFpSlider = new Swiper(".js-fp-residential-swiper", {
                slidesPerView: 1,
                speed: 400,
                pagination: {
                    el: ".js-fp-residential-pagination",
                    clickable: true,
                },
                on: {
                    init: function () {
                        $(".residential__meta").matchHeight({ remove: true });
                        $(".residential__meta-name").matchHeight({ remove: true });
                        $(".residential-meta-desc").matchHeight({ remove: true });
                        $(".m-residential__card").matchHeight();
                    },
                },
            });
        }

        if ($(".js-related-news-swiper").length) {
            const newsSwiper = new Swiper(".js-related-news-swiper", {
                slidesPerView: 1,
                speed: 400,
                pagination: {
                    el: "#news-pagination",
                    clickable: true,
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                    },
                },
            });
        }

        if ($(".js-sales-office-swiper").length) {
            const salesOfficeSwiper = new Swiper(".js-sales-office-swiper", {
                slidesPerView: 1,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
                speed: 400,
                pagination: {
                    el: ".js-sales-office-swiper-pagination",
                    clickable: true,
                    horizontalClass: 'swiper-pagination-vertical',
                },
            });
        }

        if ($(".js-table-swiper") && $(window).width() < 992) {
            let tablsSwiper = new Swiper(".js-table-swiper", {
                slidesPerView: 1,
                speed: 400,
                spaceBetween: 16,
                pagination: {
                    el: ".js-table-swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    575: {
                        slidesPerView: 2,
                    },
                },
            });
        }

        if ($('.js-table-with-tabs-swiper')) {
            let tableTabsSwipeNew = new Swiper(".js-table-with-tabs-swiper", {
                slidesPerView: 1.1,
                speed: 400,
                spaceBetween: 16,
                breakpoints: {
                    768: {
                        slidesPerView: 2.1,
                        spaceBetween: 16,
                    },
                    1200: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                },
            });
        }

        if ($(".js-table-swiper-new")) {
            let tablesSwipeNew = new Swiper(".js-table-swiper-new", {
                slidesPerView: 1.1,
                speed: 400,
                spaceBetween: 8,
                breakpoints: {
                    768: {
                        slidesPerView: 2.1,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 3.1,
                        spaceBetween: 32,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 32,
                    },
                },
            });
        }


        if ($(".js-partner-feedback-slider")) {
            let partnerSwiper = new Swiper(".js-partner-feedback-slider", {
                slidesPerView: 1,
                speed: 400,
                spaceBetween: 16,
                navigation: {
                    prevEl: '.js-partner-left',
                    nextEl: '.js-partner-right',
                },
                pagination: {
                    el: ".js-partner-feedback-slider-pagination",
                    clickable: true,
                },
            });
        }


        if ($(".js-reference-slider")) {
            let partnerSwiper = new Swiper(".js-reference-slider", {
                slidesPerView: 1,
                speed: 400,
                spaceBetween: 32,
                navigation: {
                    prevEl: '.js-reference-left',
                    nextEl: '.js-reference-right',
                },
                pagination: {
                    el: ".js-reference-pagination",
                    clickable: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 2,
                    },

                },
            });
        }

        if ($(".js-service-swiper")) {
            let partnerSwiper = new Swiper(".js-service-swiper", {
                slidesPerView: 1,
                speed: 400,
                spaceBetween: 0,
                navigation: {
                    prevEl: '.js-service-left',
                    nextEl: '.js-service-right',
                },
                pagination: {
                    el: ".js-service-pagination",
                    clickable: true,
                },
                autoHeight: true,
                breakpoints: {
                    992: {
                        autoHeight: false,
                        enabled: false,
                    },
                },
                on: {
                    slideChange: function () {
                        const index_currentSlide = this.realIndex;
                        const currentSlide = this.slides[index_currentSlide];
                        const currentId = $(currentSlide).attr('id');
                        $('.js-service-toggle.active').removeClass('active');
                        $(`.js-service-toggle[data-tab="${currentId}"]`).addClass('active');

                    }
                }
            });

        }

        if ($(".js-new-gallery-slider")) {
            var options = {
                slidesPerView: 1.3,
                slidesPerColumn: 1,
                spaceBetween: 8,
                navigation: {
                    prevEl: '.js-gallery-new-slider-prev',
                    nextEl: '.js-gallery-new-slider-next',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3.5,
                    },
                    768: {
                        slidesPerView: 2.5,
                    },

                },
            }

            /* New gallery slider on residentials page */
            var newGallerySlider = new Swiper('.js-new-galelry-slider', options);

            $('.js-gallery-type-selector').on('click', function () {
                var filter = $(this).data('type');

                $('.js-gallery-type-selector').removeClass('active');
                $(this).addClass('active');

                if (filter == 'all') {
                    $('.js-new-galelry-slider').find("[data-filter]").removeClass("non-swiper-slide").addClass("swiper-slide").removeClass('d-none');
                    newGallerySlider.destroy();
                    newGallerySlider = new Swiper('.js-new-galelry-slider', options);
                } else {
                    $('.js-new-galelry-slider').find(".swiper-slide").not("[data-filter='" + filter + "']").addClass("non-swiper-slide").removeClass("swiper-slide").addClass('d-none');
                    $('.js-new-galelry-slider').find("[data-filter='" + filter + "']").removeClass("non-swiper-slide").addClass("swiper-slide").removeClass('d-none');
                    newGallerySlider.destroy();
                    newGallerySlider = new Swiper('.js-new-galelry-slider', options);
                }
            });

            $('.js-custom-select-new-residentials').on('change', function () {
                var filter = $(this).val();
                $('.js-gallery-type-selector').removeClass('active');
                $(this).addClass('active');

                if (filter == 'all') {
                    $('.js-new-galelry-slider').find("[data-filter]").removeClass("non-swiper-slide").addClass("swiper-slide").removeClass('d-none');
                    newGallerySlider.destroy();
                    newGallerySlider = new Swiper('.js-new-galelry-slider', options);
                } else {
                    $('.js-new-galelry-slider').find(".swiper-slide").not("[data-filter='" + filter + "']").addClass("non-swiper-slide").removeClass("swiper-slide").addClass('d-none');
                    $('.js-new-galelry-slider').find("[data-filter='" + filter + "']").removeClass("non-swiper-slide").addClass("swiper-slide").removeClass('d-none');
                    newGallerySlider.destroy();
                    newGallerySlider = new Swiper('.js-new-galelry-slider', options);
                }
            })
        }


        if ($(".js-new-social-slider")) {
            var optionsSocial = {
                slidesPerView: 1.3,
                slidesPerColumn: 1,
                spaceBetween: 8,
                navigation: {
                    prevEl: '.js-social-new-slider-prev',
                    nextEl: '.js-social-new-slider-next',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 2,
                    },

                },
            }

            /* New gallery slider on residentials page */
            var newSocialSlider = new Swiper('.js-new-social-slider', optionsSocial);
        }

    });
})(jQuery);
